import { Box, Typography, Dialog } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ExpiredLinkModal = ({ open }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box
        sx={{
          padding: 4,
          textAlign: "center",
          backgroundColor: "white",
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            fontSize: 60,
            color: "#dc3545",
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 60 }} />
        </Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Link Expired
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          The link you are trying to access has expired. Please contact the
          sender for a new link.
        </Typography>
      </Box>
    </Dialog>
  );
};

export default ExpiredLinkModal;
